export class VenueStatus {
	pk: string; //:venueKey
	sk: string; //venue_station_status
	stationStatus: DeviceStatus[];
	kitchenStatus: DeviceStatus[];
	printerStatus: any[];

	connectorHeartbeat: number;
	backupService: number;
	configurationService: number;
	coreService: number;
	datafeedService: number;
	employeeMessageService: number;
	emvMonitoringService: number;
	kitchenService: number;
	mobileCheckSaveService: number;
	mobileService: number;
	schedulingService: number;
	socketService: number;

	lastHeartbeat: number;

	alertNotification: number;

	menuItemSyncChecksum: string;
	canvasSyncChecksum: string;
	lastMenuSync: number;

	errors: TransactionError[];

	public constructor(init?: Partial<VenueStatus>) {
		Object.assign(this, init);
	}
}

export class DeviceStatus {
	deviceId: number;
	lastPulse: string;
	name: string;
	isMobile: boolean;
	isEvent: boolean;
	isCredit: boolean;
	isEmail: boolean;

	public constructor(init?: Partial<DeviceStatus>) {
		Object.assign(this, init);
	}
}

export class TransactionError {
	code: string;
	transactionDateTime: string;
	checkKey: string;

	public constructor(init?: Partial<TransactionError>) {
		Object.assign(this, init);
	}
}
